'use client'
import { PopupWrapper } from '@/components'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, IconButton, Stack, Typography } from '@mui/material'

interface PopupPolicyProps {
  isOpen: boolean
  handleClose: () => void
  onAccept?: () => void
}

export const PopupPolicy = ({ isOpen, handleClose, onAccept }: PopupPolicyProps) => {
  const handleAcceptClick = () => {
    handleClose()
    onAccept?.()
  }
  return (
    <PopupWrapper isOpen={isOpen} handleClose={handleClose} width="520px" hiddenIcon>
      <Box
        sx={{
          p: {
            xs: 1,
            md: 2,
          },
        }}
      >
        {/* Header */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            mb: {
              xs: 1,
              md: 2,
            },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: '1.25rem',
                md: '1.5rem',
                lg: '2rem',
              },
              fontWeight: 600,
            }}
          >
            Chính sách bảo mật
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Stack>

        {/* Content */}
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 300,
            lineHeight: 1.5,
            overflowY: 'auto',
            mb: 2,
          }}
        >
          Chúng tôi cam kết bảo vệ quyền riêng tư và thông tin cá nhân của bạn. Khi bạn viết đánh giá sản
          phẩm, chúng tôi thu thập các thông tin như tên hiển thị, nội dung đánh giá, hình ảnh và video (nếu
          có) để công bố công khai trên website nhằm giúp khách hàng khác có thêm thông tin tham khảo khi mua
          sắm.
          <br />
          <br />
          Mọi thông tin cá nhân của bạn sẽ được mã hóa và lưu trữ an toàn theo tiêu chuẩn bảo mật cao nhất.
          Chúng tôi không chia sẻ, bán hoặc cho thuê thông tin cá nhân của bạn cho bất kỳ bên thứ ba nào mà
          không có sự đồng ý của bạn, trừ khi được yêu cầu bởi pháp luật.
          <br />
          <br />
          Bạn có quyền truy cập, chỉnh sửa hoặc xóa thông tin cá nhân của mình bất cứ lúc nào. Đánh giá của
          bạn có thể được chỉnh sửa hoặc gỡ bỏ nếu vi phạm các quy định về nội dung. Chúng tôi có thể sử dụng
          thông tin đánh giá để cải thiện chất lượng sản phẩm và dịch vụ.
          <br />
          <br />
          Bằng việc gửi đánh giá, bạn xác nhận rằng bạn đã đọc, hiểu và đồng ý với chính sách bảo mật này. Nếu
          có bất kỳ thắc mắc nào về chính sách bảo mật, vui lòng liên hệ với bộ phận hỗ trợ khách hàng của
          chúng tôi để được giải đáp.
        </Typography>

        {/* Button */}
        <Button
          fullWidth
          variant="contained"
          onClick={handleAcceptClick}
          size="large"
          sx={{
            borderRadius: '999px',
            height: '40px',
            fontSize: '14px',
            fontWeight: 600,
            textTransform: 'none',
          }}
        >
          Tôi đã hiểu
        </Button>
      </Box>
    </PopupWrapper>
  )
}
